import React, { useState } from "react";
import { Alert, Box, Slide, IconButton } from "@mui/material/";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import UpdateIcon from "@mui/icons-material/Update";
import BuildIcon from "@mui/icons-material/Build";
import { strings } from "../i18n";

const messages = {
    outages: {
        text: strings("messages.outages"),
        severity: "error",
        icon: <ErrorOutlineIcon fontSize="inherit" />,
        position: "sticky"
    },
    releases: {
        text: strings("messages.releases"),
        severity: "info",
        icon: <UpdateIcon fontSize="inherit" />,
        position: "sticky"
    },
    maintenance: {
        text: strings("messages.maintenance"),
        severity: "warning",
        icon: <BuildIcon fontSize="inherit" />,
        position: "sticky"
    }
};

export default ({ scenario, headerHeight = 64 }) => {
    const [open, setOpen] = useState(true);

    if (!scenario || !messages[scenario] || !open) return null;

    const { text, severity, icon, position } = messages[scenario];

    return (
        <Slide
            direction="down"
            in={Boolean(scenario) && open}
            mountOnEnter
            unmountOnExit
        >
            <Box
                sx={{
                    position: position,
                    top: position === "sticky" ? `${headerHeight}px` : 0,
                    left: 0,
                    right: 0,
                    zIndex: 2000
                }}
            >
                <Alert
                    severity={severity}
                    icon={icon}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{
                        borderRadius: 0,
                        fontWeight: 500,
                        "& .MuiAlert-message": {
                            width: "100%",
                            textAlign: "center"
                        }
                    }}
                >
                    {text}
                </Alert>
            </Box>
        </Slide>
    );
};
